<template>
  <div class="fc-top" @contextmenu.prevent.stop>
    <div class="tabList">
      <el-badge :hidden="gatherNum == 0" :value="gatherNum" class="item" :max="99">
        <span
          class="tabItem"
          :class="{ curStyle: item.id == curId }"
          v-for="(item, index) in tabList"
          :key="index"
          @click="setNav(item)"
          >{{ $t(item.name) }}</span
        >
      </el-badge>
    </div>
    <div class="search-box">
      <!-- <el-tooltip
        class="item"
        popper-class="fileTooltip"
        effect="dark"
        placement="bottom-start"
      >
        <div class="tips" slot="content">
          飞猫盘仅提供网络空间租赁服务，不参与内容贩卖、二次加工及推荐服务，依据国家相关法律及地方法规：我们将进行身份信息采集并在不侵犯用户隐私权的同时进行必要的机器审核。如您登记信息并上传文件即视为您已认可此要求。严禁上传、分享所有形式的非法内容。
          <a
            target="__blank"
            href="https://help.feimaoyun.com/archives/733.html"
            >《对于违规账号的处置方式》</a
          >
          <a
            target="__blank"
            href="https://help.feimaoyun.com/archives/1159.html"
            >《飞猫盘文件审核机制公示》</a
          >
        </div>
        <img class="icon" :src="$utils.getPng('web4/icon-circle-fill')" />
      </el-tooltip> -->
      <el-input
        :disabled="disabled"
        v-model="keyword"
        :placeholder="placeholder"
        @keyup.enter.native="toSearch"
      >
        <svg-btn
          v-show="keyword != ''"
          @click="clearValue()"
          slot="suffix"
          icon-class="icon-ipt-clear"
        ></svg-btn>
        <svg-btn
          @click="search()"
          slot="suffix"
          icon-class="icon-ipt-search"
        ></svg-btn>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    curId: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Number,
      default: 0,
    },
    gatherNum:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      tabList: [
        { id: 0, name: "Collection.Files", url: "/myCollection" },
        { id: 1, name: "Collection.Set", url: "/collectionSet" },
      ],
      keyword: "",
    };
  },
  created() {},
  methods: {
    setNav(item) {
      this.$router.push({
        path: item.url,
      });
    },
    search() {
      //if (this.keyword == "") {
      //  return;
      //}
      this.$emit("searchList", this.keyword);
    },
    clearValue() {
      this.keyword = "";
      this.$emit("searchList", this.keyword);
    },
    toSearch() {
      this.$emit("searchList", this.keyword);
    },
  },
};
</script>
